import React from 'react';
import {StackedInfoItem} from './InfoSectionStacked/StackedInfoItem';
import s from './StackedInfoSection.scss';
import {InfoSectionProps} from '../../InfoSectionLayout';
import {IProductInfo} from '@wix/wixstores-graphql-schema';

export enum StackedInfoSectionDataHook {
  Root = 'stacked-info-section',
}

export interface StackedInfoSectionProps extends InfoSectionProps {
  infoSectionItems: IProductInfo[];
}

export class StackedInfoSection extends React.Component<StackedInfoSectionProps> {
  public render(): JSX.Element {
    const {infoSectionItems} = this.props;

    return (
      <ul data-hook={StackedInfoSectionDataHook.Root} className={s.stacked}>
        {infoSectionItems.map((infoItem, index) => {
          return (
            <StackedInfoItem
              key={infoItem.id}
              description={infoItem.description}
              title={infoItem.title}
              index={index}
            />
          );
        })}
      </ul>
    );
  }
}
